(() => {
  if (customElements.get('k9-company-hero')) return;

  customElements.define('k9-company-hero', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      const sync = () => this.sync();
      this.motion.addEventListener('change', sync, options);
      document.addEventListener('visibilitychange', sync, options);
      this.video.addEventListener('playing', () => {
        // Playback can resolve after scrolling away or changing motion settings.
        if (!this.canPlay()) this.video.pause();
      }, options);
      this.video.addEventListener('error', () => {
        this.video.classList.add('k9-company-page__hero-video--unavailable');
      }, options);
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.sync();
      });
      this.observer.observe(this.closest('header'));
    }

    canPlay() {
      return this.isConnected && this.visible && !document.hidden && !this.motion.matches;
    }

    sync() {
      if (!this.canPlay()) {
        this.video.pause();
        return;
      }
      if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
      this.video.muted = true;
      if (this.video.paused) this.video.play().catch(() => {
        // The poster remains visible if automatic playback is blocked.
      });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
})();
